import { ApiEndpoints } from "./apiEndpoints";
import { fetchData } from "./apiHelpers";

export const sendPasswordResetEmail = async ({
  email,
  redirectTo,
  verificationType,
}: {
  email: string;
  redirectTo: string;
  verificationType: string;
}): Promise<void> => {
  try {
    const slug = `${ApiEndpoints.auth}/password-recovery`;
    const options: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, redirectTo, verificationType }),
    };
    await fetchData<void>(slug, options);
  } catch (err) {
    console.error("Error sending password reset email:", err);
    throw err;
  }
};
